<div class="ais-RefinementList">
  <!-- this div is here to simulate the ng-ais-header container -->
  <div>
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
    >
      <span *ngIf="options.label === 'CATALOG.FILTERS.UNIVERSE'" i18n="@@CATALOG.FILTERS.UNIVERSE">Category</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.CATEGORY'" i18n="@@CATALOG.FILTERS.CATEGORY">Category</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.BRANDS'" i18n="@@CATALOG.FILTERS.BRANDS">Designers</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.MODEL'" i18n="@@CATALOG.FILTERS.MODELS">Models</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.CONDITION'" i18n="@@CATALOG.FILTERS.CONDITION">Condition</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.MATERIALS'" i18n="@@CATALOG.FILTERS.MATERIALS">Materials</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.EDITORPICKS'" i18n="@@CATALOG.FILTERS.EDITORPICKS"
        >Editor's pick</span
      >
      <span *ngIf="options.label === 'CATALOG.FILTERS.SOLD'" i18n="@@CATALOG.FILTERS.SOLD">Availability</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.DISCOUNT'">
        <a *ngIf="getDiscountUrl; else discountLabel" href="{{ getDiscountUrl }}">
          <!-- SSR Case -->
          <ng-container *ngTemplateOutlet="discountLabel"></ng-container>
        </a>
        <ng-template #discountLabel><span i18n="@@CATALOG.FILTERS.DISCOUNT">Reduced prices</span></ng-template>
      </span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.WATCH_MECHANISM'" i18n="@@CATALOG.FILTERS.WATCH_MECHANISM"
        >Watch mechanism</span
      >
      <span *ngIf="options.label === 'CATALOG.FILTERS.SELLERBADGE'" i18n="@@CATALOG.FILTERS.SELLERBADGE"
        >Seller badges</span
      >
    </button>
  </div>

  <!-- Refinement body -->
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <input
      #searchInsideListInput
      type="text"
      *ngIf="options.isSearchable"
      (keyup)="state.searchForItems(searchInsideListInput.value)"
      class="vc-form-text2__input filters__checkboxList__search"
      i18n-placeholder="@@CATALOG.FILTERS.SEARCH_PLACEHOLDER.DEFAULT"
      placeholder="Search"
    />
    <ul
      class="ais-RefinementList-list"
      [ngClass]="{filters__checkboxList__scroll: items.length > 10 && !options.showMoreLimit}"
    >
      <li *ngFor="let item of items; let index = index">
        <ng-container *ngIf="item.url; else label">
          <!-- SSR Case -->
          <span class="filters_checkbox_label">
            <a href="{{ item.url }}"> <ng-container *ngTemplateOutlet="innerLabel"></ng-container> </a>
            <span class="filters_checkbox_label_count">({{ item.count }})</span>
          </span>
        </ng-container>

        <ng-template #label>
          <!-- Browser case -->
          <input
            id="{{ options.facet }}__{{ item.id || index }}"
            class="filters_checkbox_input"
            type="checkbox"
            (change)="refine($event, item)"
            [attr.checked]="item.isRefined ? 'checked' : null"
          />
          <label for="{{ options.facet }}__{{ item.id || index }}" class="filters_checkbox_label">
            <ng-container *ngTemplateOutlet="innerLabel"></ng-container>
            <span class="filters_checkbox_label_count">({{ item.count }})</span>
          </label>
        </ng-template>

        <!--
          ITEM LABEL
          This is the tempalte that'll be inserted in the <*ngTemplateOutlet="innerLabel"> placeholders
        -->
        <ng-template #innerLabel [ngSwitch]="item.label">
          <ng-container *ngSwitchCase="'sold.sold_on'" i18n="@@CATALOG.FILTERS.SOLD.SHOW">
            Show sold products
          </ng-container>
          <ng-container *ngSwitchCase="'sold.sold_off'" i18n="@@CATALOG.FILTERS.SOLD.HIDE">
            Hide sold products
          </ng-container>
          <ng-container
            *ngSwitchCase="expertArray.includes(item.label) ? item.label : !item.label"
            i18n="@@CATALOG.FILTERS.EXPERT"
          >
            Expert
          </ng-container>
          <ng-container
            *ngSwitchCase="trustedArray.includes(item.label) ? item.label : !item.label"
            i18n="@@CATALOG.FILTERS.TRUSTED"
          >
            Trusted
          </ng-container>
          <ng-container *ngSwitchDefault>
            {{ item.label }}
          </ng-container>
        </ng-template>
      </li>
    </ul>
    <vc-show-more-button
      *ngIf="options.showMoreLimit && state.canToggleShowMore"
      [isShowingMore]="state?.isShowingMore"
      (toggleShowMore)="state.toggleShowMore()"
    ></vc-show-more-button>
  </div>
</div>
